var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconProgress(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.004,
    height: 25.004,
    viewBox: "0 0 29.004 25.004",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:none;stroke:#c8c7d7;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_progress",
    transform: "translate(1 1.004)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2566",
    d: "M1031.7 1096.547c0-8.044 6.516-14.507 14.363-14a13.813 13.813 0 0 1 12.584 12.75 14.421 14.421 0 0 1-2 8.686 3.184 3.184 0 0 1-2.729 1.536h-17.439a3.189 3.189 0 0 1-2.734-1.543 14.364 14.364 0 0 1-2.045-7.429z",
    className: "cls-1",
    transform: "translate(-1031.705 -1082.519)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_92",
    d: "M0 0L0.874 0",
    className: "cls-1",
    transform: "translate(23.695 14.474)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_93",
    d: "M0 0.673L0.658 0",
    className: "cls-1",
    transform: "translate(20.571 6.459)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_94",
    d: "M0 0.856L0 0",
    className: "cls-1",
    transform: "translate(13.519 2.436)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_95",
    d: "M0.647 0.662L0 0",
    className: "cls-1",
    transform: "translate(5.608 6.472)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_96",
    d: "M0.911 0L0 0",
    className: "cls-1",
    transform: "translate(2.449 14.475)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_35",
    cx: 1.636,
    cy: 1.673,
    className: "cls-1",
    rx: 1.636,
    ry: 1.673,
    transform: "translate(11.884 15.871)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_97",
    d: "M0 4.692L4.586 0",
    className: "cls-1",
    transform: "translate(15.522 10.782)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProgress);
export default __webpack_public_path__ + "static/media/icon-progress.392ff036c41783de898e8817d0bbf024.svg";
export { ForwardRef as ReactComponent };